import { storage } from "./storage";

/** Known investor mock localStorage keys — ignored at runtime; cleared after real login. */
export const INVESTOR_MOCK_STORAGE_KEYS = [
  "investor_mock_session",
  "investor_mock_users",
  "investor_mock_kyc_by_user",
  "investor_mock_requests",
  "staff_investor_opportunity_preview",
  "staff_marketplace_product_preview",
];

function companyScopedKeys() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (
        key.startsWith("investor_portal_admin_") ||
        key.startsWith("investor_portal_capabilities_") ||
        key.startsWith("investment_hub_marketplace_admin_") ||
        key.startsWith("investment_hub_investor_operations_")
      ) {
        keys.push(key);
      }
    }
    return keys;
  } catch {
    return [];
  }
}

/**
 * One-time cleanup of legacy mock investor data from browser storage.
 * Safe to call after successful real authentication; does not affect app behavior if it fails.
 */
export function clearLegacyInvestorMockStorage() {
  try {
    [...INVESTOR_MOCK_STORAGE_KEYS, ...companyScopedKeys()].forEach((key) => {
      storage.localStorage.remove(key);
    });
  } catch {
    // ignore storage errors
  }
}
